module.exports = __webpack_public_path__ + "img/9265928.jpg";